import React from 'react';
import { Button, Modal } from 'antd';
import { ReactComponent as CrossSvg } from '@assets/icons/cross.svg';
import { ReactComponent as AWSvg } from '@assets/icons/approval-state.svg';

import './ApprovalFallbackModal.less';

type ApprovalFallbackModalProps = {
  visible: boolean;
  onClose: (value: { visible: boolean }) => void;
};

export default function ApprovalFallbackModal({
  visible,
  onClose
}: ApprovalFallbackModalProps) {
  const onCloseModal = () => {
    onClose({ visible: false });
  };

  return (
    <Modal
      open={visible}
      footer={null}
      centered={true}
      destroyOnClose
      width={480}
      zIndex={1010}
      className="approval-fallback-modal"
      onCancel={onCloseModal}
      afterClose={onCloseModal}
    >
      <CrossSvg
        className="approval-fallback-modal_close"
        onClick={onCloseModal}
      />
      <div className="modal_container">
        <div className="modal_container__approval-state">
          <AWSvg />
        </div>

        <h2
          className="modal_container__title"
          style={{
            fontSize: 22,
            width: 316,
            textAlign: 'center',
            margin: '0 auto'
          }}
        >
          This creative media hasn’t been routed for approval yet
        </h2>
        <p
          className="modal_container__subtitle"
          style={{
            width: 350,
            textAlign: 'center',
            margin: ' 12px auto 0'
          }}
        >
          Ready to route for approval? Contact your account admin to kick things
          off.
        </p>
        <Button
          type="primary"
          style={{ width: '100%', marginTop: 32 }}
          onClick={onCloseModal}
        >
          Ok
        </Button>
      </div>
    </Modal>
  );
}
